module.exports = __webpack_public_path__ + "static/mlh-trust-badge-2020-white-c1ccf11f98fd9906026e62a1732139e9.svg";